import { cn } from '../../lib/utils';

export interface LogoProps {
  /** `brand` = full-colour mark + white/teal wordmark (app); `white` = all white (hero). */
  variant?: 'brand' | 'white';
  size?: 'sm' | 'md' | 'lg';
  wordmark?: boolean;
  className?: string;
}

const sizes = {
  sm: { icon: 22, text: 'text-lg' },
  md: { icon: 28, text: 'text-[22px]' },
  lg: { icon: 34, text: 'text-2xl' },
};

/** Intrinsic size of `public/logo.png`; keeps the rendered box at the image's aspect ratio. */
const MARK_WIDTH = 314;
const MARK_HEIGHT = 265;

export function LogoMark({ size = 28, white, alt = 'CMSH.io' }: { size?: number; white?: boolean; alt?: string }) {
  return (
    <img
      src="/logo.png"
      alt={alt}
      aria-hidden={alt === '' || undefined}
      height={size}
      width={Math.round((size * MARK_WIDTH) / MARK_HEIGHT)}
      draggable={false}
      className={cn('shrink-0 select-none object-contain', white && 'brightness-0 invert')}
    />
  );
}

export function Logo({ variant = 'brand', size = 'md', wordmark = true, className }: LogoProps) {
  const s = sizes[size];
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark size={s.icon} white={variant === 'white'} alt={wordmark ? '' : 'CMSH.io'} />
      {wordmark && (
        <span className={cn('font-bold tracking-tight', s.text, variant === 'white' ? 'text-white' : 'text-text')}>
          CMSH<span className={variant === 'white' ? 'text-white' : 'text-link'}>.io</span>
        </span>
      )}
    </span>
  );
}
